import { takeRight } from "lodash";
import React, { Component, ReactNode } from "react";

import { localize } from "src/l10n";
import { Label } from "src/ui";
import Comment from "./Comment";
import CommentCreator from "./CommentCreator";
import { SocialFeedType } from "src/social-feed";

import "./CommentsContainer.scss";

type CommentsContainerProps = {
    comments: Spintr.IComment[];
    uberId: number;
    uberIsComment?: boolean;
    identity?: any;
    sendToMixpanel: boolean;
    id?: string;
    displayCommentForm?: boolean;
    targetCreatorId?: number;
    targetIsQuestion?: boolean;
    onChildReply?: any;
    hideAllComments?: boolean;
    formPlaceholder?: string | undefined;
    mentionedUsersHasAccess?: any[];
    isFeedPost?: boolean;
    feedType?: SocialFeedType;
}

interface IState {
    isDisplayingAllComments: boolean;
    autoFocusInput: boolean;
}

class CommentsContainer extends Component<CommentsContainerProps, IState> {
    private displayLimit: number = 2;

    constructor(props: CommentsContainerProps) {
        super(props);

        this.state = {
            isDisplayingAllComments: false,
            autoFocusInput: false,
        };
    }

    componentDidUpdate(prevProps: CommentsContainerProps) {
        if (this.props.displayCommentForm !== prevProps.displayCommentForm) {
            this.setState({
                autoFocusInput: true
            });
        }
    }

    public render(): ReactNode {
        const comments = (this.props.comments || []);
        let commentsToDisplay = [];

        if (this.state.isDisplayingAllComments) {
            commentsToDisplay = comments;
        } else if (!this.props.hideAllComments) {
            const answer = this.props.targetIsQuestion ?
                comments.find(x => x.isAnswer) :
                null;

            if (answer) {
                commentsToDisplay.push(answer);
            } else {
                commentsToDisplay = takeRight(comments, this.displayLimit);
            }
        }

        let placeholder = this.props.uberIsComment ? localize("Svara") : this.props.formPlaceholder;

        if (!!placeholder && placeholder.indexOf("...") === -1) {
            placeholder += "...";
        }

        return (
            <div className="CommentsContainer" id={this.props.id}>
                {
                    comments.length > commentsToDisplay.length && (
                        <div
                            className="CommentsContainer-load-more"
                            onClick={() => {
                                this.setState({
                                    isDisplayingAllComments: true
                                });
                            }}
                            role="button">
                            <Label size="small-1" color="light-blue" className="fw-medium">
                                {
                                    (this.props.uberIsComment ? localize("SHOW_ALL_ANSWERS") : localize("SHOW_ALL_COMMENTS")) +
                                    " (" +
                                    (comments.length) +
                                    ")"
                                }
                            </Label>
                        </div>
                    )
                }
                <div className="comments-wrapper">
                    {commentsToDisplay.map(comment => {
                        const key = `CommentsContainer${comment.id}`;

                        return (
                            <div className="comment-wrapper" key={key}>
                                <Comment
                                    comment={comment}
                                    isChildComment={this.props.uberIsComment}
                                    identity={this.props.identity}
                                    sendToMixpanel={this.props.sendToMixpanel}
                                    targetCreatorId={this.props.targetCreatorId}
                                    targetIsQuestion={this.props.targetIsQuestion}
                                    mentionedUsersHasAccess={this.props.mentionedUsersHasAccess}
                                    isFeedPost={this.props.isFeedPost}
                                    feedType={this.props.feedType}
                                    onChildReply={() => {
                                        this.props.onChildReply();
                                    }}
                                />
                            </div>
                        );
                    })}
                    {this.props.displayCommentForm && (
                        <div className="comment-creator">
                            <CommentCreator
                                autofocus={true}
                                uberId={this.props.uberId}
                                identity={this.props.identity}
                                placeholder={placeholder}
                                sendToMixpanel={this.props.sendToMixpanel}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default CommentsContainer;